import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import Basic from './routes/Basic';

const Calendar = ({match}) => (
	<div>
		<Switch>
			<Redirect exact from={`${match.url}/`} to={`${match.url}/overview`}/>
			<Route path={`${match.url}/overview`} component={ Basic } />
		</Switch>
	</div>
);

export default Calendar;


// WEBPACK FOOTER //
// ./app/used/calendar/index.js